import { AuthSupportSummary } from 'src/swagger-gen/web-secured/models';

export class SubPlanAssociationUserBadgeModel {
    uid: string;
    name: string;
    type: string;

    selectable: boolean;
    removable: boolean;

    constructor(badge: AuthSupportSummary) {
        this.uid = badge?.uid || null;
        this.name = badge?.value || null;
        this.type = badge?.type || null;
        this.selectable = false;
        this.removable = true;
    }
}
